if (!window.pingInit) window.pingInit = {};
if (!window.pingInit.media) window.pingInit.media = {};

window.pingInit.media.firstModelLoaded = false;
window.pingInit.media.firstVideoLoaded = false;

window.pingInit.media.firtsModelPrep = (el) => {
  if (window.pingInit.media.firstModelLoaded) return;

  var tag = document.createElement('link');
  tag.id = 'ShopifyModelStyleTag';
  tag.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
  tag.rel = 'stylesheet';
  tag.type = 'text/css';
  document.querySelector('head').prepend(tag);

  window.Shopify.loadFeatures([{
    name: 'model-viewer-ui',
    version: '1.0',
    onLoad: () => {
      window.pingInit.media.firstModelLoaded = true;
      window.pingInit.media.initModel(el);
    }
  }]);
};

window.pingInit.media.firtsVideoPrep = (el) => {
  if (window.pingInit.media.firstVideoLoaded) return;

  var tag = document.createElement('link');
  tag.id = 'ShopifyPlyrStyleTag';
  tag.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
  tag.rel = 'stylesheet';
  tag.type = 'text/css';
  document.querySelector('head').prepend(tag);

  window.Shopify.loadFeatures([{
    name: 'video-ui',
    version: '1.0',
    onLoad: () => {
      window.pingInit.media.firstVideoLoaded = true;
      window.pingInit.media.initVideo(el);
    }
  }]);
};

window.pingInit.media.initModel = (el) => {
  if (!window.pingInit.media.firstModelLoaded) {
    window.pingInit.media.firtsModelPrep(el);
    return;
  }

  if (el.tagName !== 'MODEL-VIEWER') return;
  new window.Shopify.ModelViewerUI(el);
};

window.pingInit.media.initVideo = (el) => {
  if (!window.pingInit.media.firstVideoLoaded) {
    window.pingInit.media.firtsVideoPrep(el);
    return;
  }

  if (el.tagName !== 'VIDEO') return;
  new window.Shopify.Plyr(el);
};

document.addEventListener('DOMContentLoaded', () => {
  const mediaJS = document.querySelectorAll('.init-js-media');
  if (!mediaJS.length) return;

  mediaJS.forEach(el => {
    if (el.classList.contains('media-video')) {
      window.pingInit.media.initVideo(el);
    } else if (el.classList.contains('media-model')) {
      window.pingInit.media.initModel(el);
    }
  });
});
